// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as RegionFlag$PrezzeeRibbon from "./RegionFlag.bs.js";
import * as RegionIndicator$PrezzeeRibbon from "./RegionIndicator.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";
import * as RegionIndicatorFlag$PrezzeeRibbon from "./RegionIndicatorFlag.bs.js";
import * as FaChevronRight from "@fortawesome/pro-light-svg-icons/faChevronRight";

var inlineRegionPicker = BsCssJs$PrezzeeRibbon.merge([
      Theme__Typography$PrezzeeRibbon.Styles.smallBody,
      BsCssJs$PrezzeeRibbon.style([
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.alignItems("center")
          ])
    ]);

var flagStyle = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.filter([{
              NAME: "dropShadow",
              VAL: [
                BsCssJs$PrezzeeRibbon.px(0),
                BsCssJs$PrezzeeRibbon.px(4),
                BsCssJs$PrezzeeRibbon.px(4),
                BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, {
                      NAME: "num",
                      VAL: 0.25
                    })
              ]
            }])]);

var Styles = {
  inlineRegionPicker: inlineRegionPicker,
  flagStyle: flagStyle
};

function RegionIndicatorInline(props) {
  var onChange = props.onChange;
  var onChange$1 = onChange !== undefined ? onChange : (function (param) {
        
      });
  var icon = JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
        icon: FaChevronRight.faChevronRight,
        className: BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(14))])
      });
  var clickableElem = function (r) {
    var flag = JsxRuntime.jsx(RegionFlag$PrezzeeRibbon.make, {
          src: r.flag,
          size: 24,
          className: flagStyle
        });
    return JsxRuntime.jsx(RegionIndicatorFlag$PrezzeeRibbon.make, {
                flag: flag,
                icon: Caml_option.some(icon)
              });
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(RegionIndicator$PrezzeeRibbon.make, {
                    regions: props.regions,
                    strings: props.strings,
                    selected: props.selected,
                    children: props.children,
                    clickableElem: clickableElem,
                    onChange: onChange$1
                  }),
              className: inlineRegionPicker
            });
}

var make = RegionIndicatorInline;

export {
  Styles ,
  make ,
}
/* inlineRegionPicker Not a pure module */
